<template>
  <div class="h-full w-full relative flex items-center justify-center earn-shake">
    <img :src="imageUrl" class="relative z-[4] h-full object-contain" />
    <img
      src="../assets/images/pirate-figure-back-shadow.svg"
      class="absolute min-w-[100px] z-[2] top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2"
    />
    <img
      v-if="props.whiteBackShadow"
      src="../assets/images/pirate-figure-white-back-shadow.svg"
      class="absolute min-w-[100px] z-[2] top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2"
    />
    <img
      v-if="props.blackShadow"
      src="../assets/images/pirate-figure-bottom-shadow-black.svg"
      class="absolute z-[2] left-1/2 -translate-x-1/2 ms-[1px]"
      :class="bigShadow ? 'w-[140px] -bottom-3 ' : 'w-[35px] -bottom-1 '"
    />
    <img
      v-else-if="props.lightShadow"
      src="../assets/images/pirate-light-shadow.svg"
      class="absolute z-[2] left-1/2 -translate-x-1/2 ms-[1px]"
      :class="bigShadow ? 'w-[140px] -bottom-3 ' : 'w-[35px] -bottom-1 '"
    />
    <img
      v-else
      src="../assets/images/pirate-figure-bottom-shadow.svg"
      class="absolute z-[2] -bottom-2 left-1/2 -translate-x-1/2 ms-1"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  blackShadow: {
    type: Boolean,
    required: false,
    default: false
  },
  lightShadow: {
    type: Boolean,
    required: false,
    default: false
  },
  whiteBackShadow: {
    type: Boolean,
    required: false,
    default: false
  },
  bigShadow: {
    type: Boolean,
    required: false,
    default: false
  },
  image: {
    type: String,
    required: false,
    default: 'captain_blacbeard.svg'
  },
  imageUrl: {
    type: String,
    required: false,
    default: ''
  }
})

const imageUrl = computed(() => {
  if (props.imageUrl === '') {
    return new URL(`../assets/images/characters/${props.image}`, import.meta.url).href
  }

  return props.imageUrl
})
</script>
